import {
    cmCrowdTest,
    sotsAbility, sotsGameplay, sotsWizards, sotsShield, sotsBoss, sotsTank, sotsDialogue,
    zcGameplay, zcMinigame, zcStory,
    harPanel, harCreation, harFkIk,
    effectHeart, monkeyStyled,
    musSomeBossaNova, sbnProjectFile,
    ss_preview, ss_nodeGroup, cg_normalDog, cg_potion,
    td_preview,
    bc_gameplay, bc_shop,
    storify_account, storify_erd, storify_contribute, storify_rating,
    roam_drawing, roam_electricity, roam_instrument, roam_submarine, roam_trash_clean, roam_water_pour, roam_map, roam_achievements,
    gomoku_banner, gomoku_play, gomoku_uml, gomoku_undo,
    garden_banner, garden_boing, garden_prediction, garden_save, garden_showcase, garden_towerplace,
    portfolio_banner, portfolio_routing, portfolio_responsive, portfolio_lazy,
    mangastone_banner, mangastone_filter, mangastone_scroll
} from './assets'

// Icons
import { ReactComponent as CSharpLogo } from "./assets/images/icons/csharp-original.svg";
import { ReactComponent as JavaLogo } from "./assets/images/icons/java-original.svg";
import {ReactComponent as JQueryLogo} from "./assets/images/icons/jquery-original.svg";
import {ReactComponent as MongoDBLogo} from "./assets/images/icons/mongodb-original.svg";
import {ReactComponent as BootstrapLogo} from "./assets/images/icons/bootstrap-original.svg";
import {ReactComponent as HTMLLogo} from "./assets/images/icons/html5-original.svg";
import {ReactComponent as CSSLogo} from "./assets/images/icons/css3-original.svg";
import {ReactComponent as JSLogo} from "./assets/images/icons/javascript-original.svg";
import {ReactComponent as BlenderLogo} from "./assets/images/icons/blender-original.svg";
import {ReactComponent as PythonLogo} from "./assets/images/icons/python-original.svg";
import {ReactComponent as FirebaseLogo} from "./assets/images/icons/firebase-original.svg";
import {ReactComponent as NodeJsLogo} from "./assets/images/icons/nodejs-original.svg";
import {ReactComponent as MySqlLogo} from "./assets/images/icons/mysql-original.svg";
import {ReactComponent as UnityLogo} from "./assets/images/icons/unity-original.svg";
import {ReactComponent as ExpressLogo} from "./assets/images/icons/express-original.svg";
import {ReactComponent as ReactLogo} from "./assets/images/icons/react-original.svg";
import {ReactComponent as ReactRouterLogo} from "./assets/images/icons/reactrouter-original.svg";
import {ReactComponent as MaterialuiLogo} from "./assets/images/icons/materialui-original.svg";
import {ReactComponent as AndroidStudioLogo} from "./assets/images/icons/androidstudio-original.svg";

const java = {text:"Java", icon: <JavaLogo />}
const javaFx = {text: "JavaFX", icon: null}
const jQuery = {text: "jQuery", icon: <JQueryLogo />}
const express = {text: "Express", icon: <ExpressLogo />}
const mongoDb = {text: "MongoDB", icon: <MongoDBLogo />}
const bootstrap = {text: "Bootstrap", icon: <BootstrapLogo />}
const html = {text: "HTML", icon: <HTMLLogo />}
const css = {text: "CSS", icon: <CSSLogo />}
const js = {text: "JS", icon: <JSLogo />}
const blender = {text:"Blender 3D", icon: <BlenderLogo />}
const python = {text:"Python", icon: <PythonLogo />}
const blenderPythonAPI = {text:"Blender Python API", icon: null}
const cakewalk = {text: "Cakewalk", icon: null}
const firebase = {text: "Firebase", icon: <FirebaseLogo />}
const nodejs = {text:"Node.js", icon: <NodeJsLogo />}
const mySql = {text:"MySQL", icon: <MySqlLogo />}
const unity = {text:"Unity", icon: <UnityLogo />}
const cSharp = {text:"C#", icon: <CSharpLogo />}
const react = {text:"React", icon: <ReactLogo />}
const reactRouter = {text:"React Router", icon: <ReactRouterLogo />}
const materialUI = {text:"Material UI", icon: <MaterialuiLogo />}
const androidstudio = {text:"Android Studio", icon: <AndroidStudioLogo />}

/*
export const HomeMedia = [
    {
        type: "video",
        url: sotsGameplay
    },
    {
        type: "video",
        url: zcMinigame
    },
    {
        type: "video",
        url: assessmentClip
    },
    {
        type: "video",
        url: cmCrowdTest
    },
]
*/
export const SotsMedia = {
    thumbnail: sotsDialogue,
    media:[
        {
            type: "video",
            url: sotsGameplay
        },
        {
            type: "video",
            url: sotsTank
        },
        {
            type: "video",
            url: sotsWizards
        },
        {
            type: "video",
            url: sotsShield
        },
        {
            type: "img",
            title: "Secret of the Square Abilities",
            img: sotsAbility
        },
        {
            type: "img",
            title: "Secret of the Square Dialogue",
            img: sotsDialogue
        },
        {
            type: "img",
            title: "Secret of the Square Boss",
            img: sotsBoss
        },
    ]
}

export const SotsDesc = {
    key: "sots",
    projName: "SECRET OF THE SQUARE",
    date: "May 2018 - June 2018",
    timeframe: "(6 weeks)",
    purpose: "Created for a Programming Course",
    about:  "Secret of the Square is a minimalistic top-down shooter game where you play as a square surviving " +
            "waves of circular enemies for 10 levels. It was made in JavaFX in 6 weeks for the final project of a " +
            "programming course.",
    summary: "Top-down shooter game.",
    features: [
        "10 customized levels",
        "6 enemy types",
        "5 overall abilities",
        "A boss enemy",
        "An endless mode",
        "A wrestling-esque ring to fling you around",
        "Skippable dialogue",
    ],
    technologies: [
        //"JavaFX",
        //"Java",
        java,
        javaFx
    ],
    contributors: [
        "Timothy Tan"
    ],
}

export const zcMedia = {
    thumbnail: zcStory,
    media:[
        {
            type: "video",
            url: zcGameplay
        },
        {
            type: "video",
            url: zcMinigame
        },
        {
            type: "img",
            title: "ZeroContact story",
            img: zcStory
        }
    ]
}

export const zcDesc = {
    key: "zerocontact",
    projName: "ZERO CONTACT",
    date: "April 2020 - May 2020",
    timeframe: "(5 Weeks)",
    purpose: "Created for a BCIT Projects course",
    about:  "Zero Contact is a story-driven roguelike game made in 5 weeks about surviving in a pandemic. " +
            "Each day, you are put into a situation that affects your resource bars. Once your resources " +
            "hit zero, you lose and have to start again. The goal is to last as long as possible until a cure is found.",
    summary: "A story-driven roguelike web game with account saving.",
    features: [
        "40+ card situations",
        "6+ characters",
        "A minigame to collect items",
        "5+ item types",
    ],
    technologies: [
        // "jQuery",
        // "Express",
        // "MongoDB",
        // "Bootstrap",
        // "HTML, CSS, JS"
        jQuery,
        express,
        mongoDb,
        bootstrap,
        html, css, js
    ],
    contributors: [
        "Chris Y.",
        "Michael L.",
        "Gabriel B.",
        "Matt M."
    ],
    contributions: [
        "Minigame",
        "Tutorial",
        "Item System / Inventory"
    ],
    links: [
        {
            url:"https://github.com/chrisyandev/COMP_2800_Team_BBY-04_ZeroContact",
            icon: "fab fa-github"
        },
        // {
        //     name:"Website",
        //     url:"http://zerocontact.xyz/"
        // },
    ]
}

export const harMedia = {
    thumbnail: harPanel,
    media: [
        {
            type: "video",
            url: harCreation
        },
        {
            type: "video",
            url: harFkIk
        },
        {
            type: "img",
            title: "Hair Autorig Addon Panel",
            img: harPanel
        }
    ]
}

export const harDesc = {
    key: "hairautorig",
    projName: "HAIR AUTORIG",
    date: "Dec 2019 - Mar 2020",
    timeframe: "(2 months)",
    purpose: "Personal project",
    about:  "Mesh Hair Autorig is a Blender addon intended for creating rigs out of chains of bones. " +
            "It takes in a chain of bones as input and outputs a fully-functional rig complete with FK, IK and Tweak bones. " +
            "Rigs come with many utility functions such as FK-IK snapping." +
            "This addon could be used for rigging any kind of strand but its features are " +
            "mostly tailored for mesh-based hair.",
    summary: "A CGI addon that automatically rigs a chain of bones.",
    features: [
        "Auto-creates FK, IK, Tweak, Snap, Root Bones",
        "Custom bone properties",
        "Custom bone display objects",
        "FK/ IK snap functions",
        "Utility Button and Functions",
    ],
    technologies: [
        // "Python",
        // "Blender 3D",
        // "Blender Python API"
        python,
        blender,
        blenderPythonAPI,
    ],
    contributors: [
        "Timothy Tan"
    ],
    links: [
        {
            url:"https://github.com/Timitan/Mesh-Hair-Autorig",
            icon: "fab fa-github"
        }
    ]
}

export const assessmentMedia = {
    thumbnail: null,
    media:[
        {
            type: "video",
            url: "https://youtu.be/3W4cles7zao"
        },
    ]
}

export const assessmentDesc = {
    key: "assessment",
    projName: "ASSESSMENT",
    date: "Oct 2016 - Jun 2017",
    timeframe: "(8 months)",
    purpose: "Personal project",
    about:  "Assessment is a test CGI project where I explored and learned more of the technical skills to make a short animation. " +
            "In the process of making this video, I rigged a wooden humanoid doll model, used curves to make visual effects, created particle effects, and " +
            "made different types of materials.",
    summary: "A CGI animation exploring VFX, shading, and animation.",
    technologies: [
        //"Blender"
        blender
    ],
    contributors: [
        "Timothy Tan"
    ],
    links: [
        {
            url:"https://youtu.be/3W4cles7zao",
            icon: "fa fa-youtube-play",
            style: {width:"50px", color:"#c4302b"}
        },
    ]
}

export const testVidsMedia = {
    thumbnail: monkeyStyled,
    media:[
    {
        type: "img",
        title: "Cel-shaded stylied monkey",
        img: monkeyStyled
    },
    {
        type: "video",
        url: cmCrowdTest
    },
    // {
    //     type: "img",
    //     title: "Minecraft house",
    //     img: mcHouse
    // },
    {
        type: "img",
        title: "Motion Graphics, Effect Heart",
        img: effectHeart
    },
    // {
    //     type: "img",
    //     title: "CS:GO Model screenshots",
    //     img: csgoModels
    // }
    ]
}

export const testVidsDesc = {
    key: "misc",
    projName: "SMALL PROJECTS",
    date: "2014 - 2019",
    purpose: "Series of small Blender projects",
    about:  "The following videos and screenshots consists of small cgi projects over the years that " +
            "aren't large enough to be featured on its own. This is just a quick way " +
            "to compile all the things I've done over the years.",
    summary: "Collection of small Blender projects.",
    features: [
        "A Cel-shaded, stylized monkey (Suzanne)",
        "Crowd Simulation (CrowdMaster addon)",
        "Motion graphics (Animation Nodes Addon)",
    ],
    technologies: [
        //"Blender",
        blender
    ],
    contributors: [
        "Timothy Tan"
    ],
}

export const sbnMedia = {
    thumbnail: sbnProjectFile,
    media: [
        {
            type: "audio",
            url: musSomeBossaNova
        },
        {
            type: "img",
            title: "Some Bossa Nova project screenshot",
            img: sbnProjectFile
        }
    ]
}

export const sbnDesc = {
    key: "bossa",
    projName: "SOME BOSSA NOVA",
    date: "2019",
    purpose: "Personal project",
    about:  "This song was made after studying a little bit of jazz and bossa nova composition. It is unmixed and mastered" +
            " but it is a nice little project that was enjoyable to produce.",
    summary: "A short 2-minute Bossa Nova composition.",
    technologies: [
        //"Cakewalk",
        cakewalk
    ],
    contributors: [
        "Timothy Tan"
    ],
}

export const ssMedia = {
    thumbnail: ss_nodeGroup,
    media: [
        {
            type: "video",
            url: ss_preview
        },
        {
            type: "img",
            title: "Stylized shader node group settings",
            img: ss_nodeGroup
        }
    ]
}

export const ssDesc = {
    key: "toon",
    projName: "STYLIZED TOON SHADER",
    date: "Nov 2019 - Present",
    purpose: "Personal project",
    about:  "This project is for creating stylized art in Blender 2.8 EEVEE. This shader " +
            "can be used for stylized 3D art and animations. It also includes many features " +
            "to tweak the shader by hand instead of relying only on lighting.",
    summary: "A CGI project exploring stylized shading.",
    features: [
        "Inputs for color textures",
        "Input for normal textures",
        "Tweak texture input for rim, shadow, light",
        "Vertex color tweaking",
        "Rim lighting and texture",
        "Lighting color influence",
        "Blur properties and textures for smoother transitions",
        "Customizable shadows"
    ],
    technologies: [
        //"Blender 2.8 EEVEE",
        blender
    ],
    contributors: [
        "Timothy Tan"
    ],
}

export const tdMedia = {
    thumbnail: null,
    media: [
    {
        type: "img",
        title: "Preview of an unnamed tower defense game",
        img: td_preview
    }
    ]
}

// export const tdDesc = {
//     key: "unfinishedtd",
//     projName: "UNNAMED/ UNFINISHED TOWER DEFENSE",
//     date: "August 2020 - Present",
//     timeframe: "(unfinished)",
//     purpose: "Done for leisure/ personal project",
//     about:  "This tower defense game is currently unfinished but its concept is that " +
//             " towers/traps have limited uses. I wanted to make a tower defense game that " +
//             " revolves around the traps you would place on the pathways in other games. " +
//             " Hopefully this would encourage players to be more strategic in planning before waves" +
//             " and make use of the entire map. This project would also be built off of the tutorials by " +
//             " Brackeys on Youtube and would be modified to suit this project.",
//     features: [
//         "TBD",
//     ],
//     technologies: [
//         "Unity",
//         "C#",
//         "Blender",
//     ],
//     contributors: [
//         "Timothy Tan"
//     ],
// }

export const bcDesc = {
    key: "handwash",
    projName: "PROJECT HANDWASH",
    date: "Jan 2020 - April 2020",
    timeframe: "(4 months)",
    purpose: "Created for a BCIT Projects Course",
    about:  "Project handwash is an idle web app that shows the effects and behaviors of germs " +
            "that may come into contact with users' hands. Germs will appear and accumulate on the hand in the app which " +
            "serves as a reminder that hands will get dirty overtime. Its purpose is to give a reminder to users " +
            "that washing their hands frequently can help to prevent any sickness or infection.",
    summary: "An idle web app motivating handwashing.",
    features: [
        "5+ Shop items",
        "Bacteria Multiplication",
        "Login System with Firebase",
        "Statistics",
        "Leaderboard"
    ],
    technologies: [
        // "HTML, CSS, JS",
        // "Bootstrap",
        // "Firebase"
        bootstrap,
        firebase,
        html, css, js
    ],
    contributions: [
        "Login System",
        "Bacteria Multiplication & Animation",
        "Data persistence"
    ],
    contributors: [
        "Joban N.",
        "Gaurav K."
    ],
    links: [
        {
            url:"https://github.com/Timitan/Project_handwash",
            icon: "fab fa-github"
        },
    ]
}

export const bcMedia = {
    thumbnail: bc_shop,
    media: [
        {
            type: "video",
            url: bc_gameplay
        },
        {
            type: "img",
            title: "Project Handwash Shop",
            img: bc_shop,
        }
    ]
}

export const storifyMedia = {
    thumbnail: storify_erd,
    media: [
        {
            type: "video",
            url: storify_contribute
        },
        {
            type: "video",
            url: storify_rating  
        },
        {
            type: "video",
            url: storify_account
        },
        {
            type: "img",
            title: "Entity Relationship Diagram of the Storify database",
            img: storify_erd
        },
        // {
        //     type: "img",
        //     title: "Database view of user contributions to a story",
        //     img: storify_mysql
        // },
    ]
}

export const storifyDesc = {
    key: "storify",
    projName: "STORIFY",
    date: "March 2022 - April 2022",
    timeframe: "(2 months)",
    purpose: "Created for a BCIT Course",
    about:  "Storify is a web app where users can contribute single words to create sentences which makes stories. Users can " +
            "then view and rate finished stories on the homepage. This web app requires registration and authentication " +
            "before users can contribute to stories so that the app can keep track of their contributions and likes.",
    summary: "A web app where users collectively create stories word by word.",
    features: [
        "Single word story contribution system",
        "User Registration and Authentication",
        "Like and unlike rating system",
    ],
    technologies: [
        // "HTML, CSS, JS",
        // "Node.js",
        // "MySQL",
        mySql,
        nodejs,
        html, css, js,
    ],
    contributions: [
        "Database ERD design",
        "Backend API Endpoints",
        "Backend SQL queries",
        "Regex Input Validation",
    ],
    contributors: [
        "Charles P.",
        "Aidan T."
    ],
    links: [
        {
            url:"https://github.com/Timitan/ISA-Storify-Local",
            icon: "fab fa-github"
        },
    ]
}

export const roamMedia = {
    thumbnail: roam_map,
    media: [
        {
            type: "video",
            url: roam_water_pour
        },
        {
            type: "video",
            url: roam_drawing
        },
        {
            type: "video",
            url: roam_trash_clean 
        },
        {
            type: "video",
            url: roam_submarine
        },
        {
            type: "video",
            url: roam_instrument
        },
        {
            type: "video",
            url: roam_electricity
        },
        {
            type: "img",
            title: "Map of 5 ROAM worlds",
            img: roam_map
        },
        {
            type: "img",
            title: "Achievements panel for ROAM minigames",
            img: roam_achievements
        }
    ]
}

export const roamDesc = {
    key: "roam",
    projName: "ROAM",
    date: "January 2021 - August 2021",
    timeframe: "(8 months)",
    purpose: "Mobile Application Developer Co-op Position at YaltySoft",
    about:  "ROAM is a mobile app with 30+ minigames contained in 5 themed worlds. It has multiple achievements and completion " +
            "medals specific to each minigame. Minigames range from being educational point-and-click to being physics-based.",
    summary: "A mobile app where users play 35+ themed minigames in 5 worlds.",
    features: [
        "5 worlds with 6+ minigames in each world",
        "25+ Achievements for minigames",
        "Character customization",
    ],
    technologies: [
        // "C#",
        // "Unity",
        cSharp,
        unity,
    ],
    contributions: [
        "20+ ROAM minigames",
        "Endless 'arcade' versions of minigames",
        "Vendor Dashboard Updates",
        "Trophy and Achievement system",
        "Character Customization",
        "Google Play Store Deployment"
    ],
    // links: [
    //     {
    //         name:"Website",
    //         url:"https://playroamgame.com/"
    //     },
    // ]
}

export const gomokuMedia = {
    thumbnail: gomoku_banner,
    media: [
        {
            type: "video",
            url: gomoku_play
        },
        {
            type: "video",
            url: gomoku_undo
        },
        {
            type: "img",
            title: "UML Class diagram of Gomoku game",
            img: gomoku_uml 
        }
    ]
}

export const gomokuDesc = {
    key: "gomoku",
    projName: "GOMOKU JAVA",
    date: "Summer 2023",
    timeframe: "(2 months)",
    purpose: "Created for a SFU course",
    about:  "GOMOKU JAVA is a standalone Java application replicating the mechanics from the game: 'Gomoku'. It was created in a team " +
            "of 4 people intended to learn about software development and different design patterns. A few design patterns were used that " +
            "were of note. The Flyweight design pattern was used for reducing memory for pieces sharing the same graphics. The factory method " +
            "was used to create buttons with different designs. A memento was used to save and restore board states.",
    summary: "A standalone Gomoku application made for learning software development.",
    features: [
        "Human vs Human",
        "Human vs Easy/ Hard AI",
        "Timer, history and undo functions",
        "Flyweight, Factory Methods, Memento design pattern implementations"
    ],
    technologies: [
        java,
    ],
    contributions: [
        "Button Factory method",
        "Panel and UI creation"
    ],
    contributors: [
        "Cem S.",
        "Derick X.",
        "Quanzhao L.",
        "Takuto S."
    ],
    // links: [
    //     {
    //         name:"Website",
    //         url:"https://playroamgame.com/"
    //     },
    // ]
}

export const gardenMedia = {
    thumbnail: garden_banner,
    media: [
        {
            type: "video",
            url: garden_showcase
        },
        {
            type: "video",
            url: garden_boing
        },
        {
            type: "video",
            url: garden_towerplace
        },
        {
            type: "video",
            url: garden_prediction
        },
        {
            type: "video",
            url: garden_save
        },
    ]
}

export const gardenDesc = {
    key: "gardentd",
    projName: "TIMELESS GARDEN",
    date: "2022 - Present",
    timeframe: "Ongoing",
    purpose: "Created as a personal project",
    about:  "Timeless Garden is a 3D physics based, bullet-time tower defense inspired by tool-assisted speedruns where every tower " +
            "is manually controlled and activated. It combines tower defense mechanics and bullet-time strategy games to create a " +
            "chain-reaction style of gameplay where players have complete control. Using save states, different time scales and " +
            "a 'prediction mode', players can activate multiple types of turrets at specific times to stop enemies.",
    summary: "A chain reaction, bullet-time tower defense game inspired by tool-assisted speedruns.",
    features: [
        "6 tower types",
        "4 enemy variants",
        "8+ buff and debuff types",
        "Physics based interactions",
        "A stylized shading style"
    ],
    technologies: [
        cSharp,
        unity,
        blender,
    ],
    // links: [
    //     {
    //         name:"Website",
    //         url:"https://playroamgame.com/"
    //     },
    // ]
}

export const normalDogMedia = {
    thumbnail: null,
    media:[
        // {
        //     type: "video",
        //     url: "https://youtu.be/r5jHPWpZn_8"
        // },
        {
            type: "video",
            url: cg_normalDog
        },
    ]
}

export const normalDogDesc = {
    key: "normaldog",
    projName: "NORMAL DOG ANIMATION",
    date: "August 2023",
    timeframe: "(1 month)",
    purpose: "Personal project",
    about:  "This animation is a short 3D Blender animation exploring stylized shading and animation. It uses a custom made " +
            "shader and line art stroke objects to create a 2D hand-drawn feel.",
    summary: "CGI animation exploring stylized shading and animation.",
    technologies: [
        //"Blender"
        blender
    ],
    contributors: [
        "Timothy Tan"
    ],
    links: [
        {
            url:"https://youtu.be/r5jHPWpZn_8",
            icon: "fa fa-youtube-play",
            style: {width:"50px", color:"#c4302b"}
        },
    ]
}

export const potionMedia = {
    thumbnail: null,
    media:[
        // {
        //     type: "video",
        //     url: "https://youtu.be/r5jHPWpZn_8"
        // },
        {
            type: "video",
            url: cg_potion
        },
    ]
}

export const potionDesc = {
    key: "potion",
    projName: "POTION LOOP ANIMATION",
    date: "July 2023",
    timeframe: "(2 months)",
    purpose: "Personal project",
    about:  "This spinning potion loop consists of a shader breakdown for a stylized shading effect with compositor effects. It " +
            "uses a custom made shader in Blender EEVEE with freestyle and line textures.",
    summary: "CGI animation exploring stylized shading and animation.",
    technologies: [
        //"Blender"
        blender
    ],
    contributors: [
        "Timothy Tan"
    ]
}

export const portfolioMedia = {
    thumbnail: portfolio_banner,
    media: [
        {
            type: "video",
            url: portfolio_routing
        },
        {
            type: "video",
            url: portfolio_lazy
        },
        {
            type: "video",
            url: portfolio_responsive
        },
    ]
}

export const portfolioDesc = {
    key: "portfolio",
    projName: "PORTFOLIO WEBSITE",
    date: "2020, 2022, 2025",
    timeframe: "(Ongoing)",
    purpose: "Personal project",
    about:  "This portfolio website is a single page application that showcases my projects. I continuously developed and updated it over the years " + 
            "as a way to learn about React. It consists of many projects I'm proud of and many components which make it easy to update in the future.",
    summary: "The portfolio website you're currently looking at!",
    features: [
        "Responsive design",
        "Material UI (MUI) components",
        "Carousel for image, music, video media",
        "Lazy loading for multiple projects on a single page",
        "Usage of react-router for routing between different pages",
        "Usage of react-transition-group for smooth page transitions"
    ],
    technologies: [
        reactRouter,
        materialUI,
        react
    ],
}

export const mangastoneMedia = {
    thumbnail: mangastone_banner,
    media: [
        {
            type: "video",
            url: mangastone_scroll
        },
        {
            type: "video",
            url: mangastone_filter
        }
    ]
}

export const mangastoneDesc = {
    key: "mangareader",
    projName: "MANGA READER",
    date: "Fall 2021",
    timeframe: "(2 months)",
    purpose: "BCIT Project",
    about:  "This manga reader project consists of an app that allows for a smooth and integrated manga reading experience for users on Android devices. " +
            "With this app, users can see aggregated rating and manga data from both " +
            "MangaDex and AniList sources. It also features history and favorite pages that allow users to see any previously viewed or saved manga. " + 
            "Originally made in 2021 for a BCIT course with a group of 2 other people.",
    summary: "An Android manga image reader app that uses data from MangaDex and AniList.",
    features: [
        "Searching and filtering for manga",
        "Image loading and caching",
        "Favoriting system",
        "Reading history",
        "Dark mode",
    ],
    technologies: [
        java,
        firebase,
        androidstudio 
    ],
    contributions: [
        "HTTP requests to MangaDex and AniList APIs",
        "Searching and Filtering features",
        "Image loading and caching using Picasso",
    ],
    contributors: [
        "Justin P.",
        "Gabriel B."
    ],
    links: [
        {
            url:"https://github.com/Timitan/manga-reader",
            icon: "fab fa-github"
        },
    ]
}


//************************************************************************* */
// Create Components out of ProjectData and media

export const musicList = {
    list:[[sbnDesc, sbnMedia]],
    route: "/projects/music",
    iconClass: "fas fa-music",
    iconStyle: {},
    title: "Music"
};

export const cgiList = {
    list: [
        [normalDogDesc, normalDogMedia],
        [potionDesc, potionMedia],
        [ssDesc, ssMedia], 
        //[assessmentDesc, assessmentMedia], 
        [testVidsDesc, testVidsMedia]
    ],
    route: "/projects/cgi",
    iconClass: "fas fa-video",
    iconStyle: {},
    title: "CGI",
};

export const codingList = {
    list:[
        [portfolioDesc, portfolioMedia],
        [gardenDesc, gardenMedia],
        [storifyDesc, storifyMedia],
        [roamDesc, roamMedia],
        [mangastoneDesc, mangastoneMedia],
        [harDesc, harMedia],
        [SotsDesc, SotsMedia],
        [zcDesc, zcMedia],
        [gomokuDesc, gomokuMedia],
        [bcDesc, bcMedia],
        //[tdDesc, tdMedia]
    ],
    route: "/projects/coding",
    iconClass: "fa fa-code",
    iconStyle: {width: "125%"},
    title: "Coding"
};

export const projectsList = [codingList, cgiList, musicList]
  
const exportedData = {
    //HomeMedia,
    // SotsMedia, SotsDesc,
    // zcMedia, zcDesc,
    // harMedia, harDesc,
    // assessmentDesc, assessmentMedia,
    // testVidsDesc, testVidsMedia,
    // sbnDesc, sbnMedia,
    // ssMedia, ssDesc,
    // bcMedia, bcDesc,
    musicList, cgiList, codingList,
    projectsList
    //ProjectMedia2,
    //ProjectDesc2
};

export default exportedData;